/**
 * The longest comment the API stores. The composer stops typing here so a
 * reader finds out before sending, not from a rejected request. Keep it equal
 * to `COMMENT_BODY_MAX_LENGTH` in the API's comment schema.
 */
export const COMMENT_MAX_LENGTH = 5000;

/** How close to the limit the composer starts counting. */
export const COMMENT_COUNT_FROM = 4500;
